import React, { useState, useEffect } from 'react';
import { Box, Typography, Container, CardMedia } from '@mui/material';
import Zoom from 'react-medium-image-zoom';
import 'react-medium-image-zoom/dist/styles.css';
import SEO from '../../components/SEO';

const images = [
  '/images/Path1.jpg',
  '/images/Path2.jpg',
  '/images/Path3.jpg',
  '/images/Path4.jpg',
  '/images/Path5.jpg',
  '/images/Path6.jpg',
  '/images/Path7.jpg',
  '/images/Path8.jpg',
];

const PathwayLights = ({ darkMode }) => {
  const [showAllImages] = useState(false);
  // const scrollToTop = () => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: 'smooth',
  //   });
  // };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

 

  const imagesToShow = showAllImages ? images : images.slice(0, 4);

  const chunkImages = (arr, size) => {
    const chunks = [];
    for (let i = 0; i < arr.length; i += size) {
      chunks.push(arr.slice(i, i + size));
    }
    return chunks;
  };

  const imageRows = chunkImages(imagesToShow, 4);

  return (
    <>
      {/* SEO Meta Tags for Pathway Lights */}
      <SEO 
        title="Pathway Lights Services Colombo, Western Province | Outdoor Pathway Lighting Sri Lanka"
        description="Professional pathway lights services in Colombo, Gampaha, Kalutara, Western Province. Outdoor pathway lighting for weddings, events, gardens. Best pathway lights Sri Lanka."
        keywords="pathway lights, pathway lights Colombo, pathway lights Western Province, pathway lighting, outdoor pathway lights, garden pathway lights, wedding pathway lights, event pathway lighting, walkway lights, decorative pathway lights, professional lighting services, Colombo, Gampaha, Kalutara, Western Province, Sri Lanka, Miracle Lighting"
        url="https://miraclelighting.lk/Pathway-Lights"
      />
      
      <Container
      sx={{
        py: 8,
        backgroundColor: darkMode ? '#000000' : '#FFFFFF',
        color: darkMode ? '#FFD700' : '#000',
        borderRadius: '8px',
      }}
    ><Typography
                           variant="h3"
                           gutterBottom
                           sx={{
                             mt: 4,
                             mb: 5,
                             color: darkMode ? '#FFD700' : '#000000',
                             textAlign: 'center',
                             fontWeight: 'bold',
                             textShadow: darkMode ? '0 2px 4px rgba(255, 215, 0, 0.5)' : '0 2px 4px rgba(0, 0, 0, 0.2)',
                             position: 'relative',
                           
                           }}
                         >
        Pathway Lights
      </Typography>
      <Typography variant="body1" paragraph sx={{ mt: 5, mb: 5, textAlign: 'center' }}>
     Our pathway lighting not only enhances safety but also brings a decorative touch to your venue's walkways.  we  line paths with elegance and care. This service is perfect for weddings, garden parties, or temple events where guidance meets glamour.
  </Typography>

      {/* Image Gallery */}
      <Box sx={{ mt: 4 }}>
        {imageRows.map((row, rowIndex) => (
          <Box 
            key={rowIndex}
            sx={{ 
              display: 'flex', 
              flexWrap: 'wrap', 
              justifyContent: 'center', 
              gap: 2, 
              mb: 2 
            }}
          >
            {row.map((image, index) => {
              const globalIndex = rowIndex * 4 + index;
              return (
                <Zoom key={globalIndex}>
                  <Box
                    sx={{
                      width: '150px',
                      height: '120px',
                      cursor: 'pointer',
                      border: darkMode ? '2px solid #FFD700' : '2px solid #1E90FF',
                      borderRadius: '8px',
                      transition: 'transform 0.3s ease-in-out',
                      '&:hover': { transform: 'scale(1.1)' },
                    }}
                  >
                    <CardMedia
                      component="img"
                      image={image}
                      alt={`Pathway Lights ${globalIndex + 1}`}
                      sx={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '8px' }}
                    />
                  </Box>
                </Zoom>
              );
            })}
          </Box>
        ))}
      </Box>

      {/* See More/See Less Button */}
      {/* <Box sx={{ mt: 4, textAlign: 'center' }}>
        {!showAllImages && images.length > 4 ? (
          <Button 
            onClick={handleSeeMore}
            sx={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: darkMode ? '#FFD700' : '#FFD700',
              color: 'black',
              '&:hover': {
                backgroundColor: darkMode ? '#4A4A4A' : '#4A4A4A',
                color: '#FFD700',
              },
            }}
          >
            See More
          </Button>
        ) : showAllImages ? (
          <Button 
            onClick={handleSeeLess}
            sx={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: darkMode ? '#FFD700' : '#FFD700',
              color: 'black',
              '&:hover': {
                backgroundColor: darkMode ? '#4A4A4A' : '#4A4A4A',
                color: '#FFD700',
              },
            }}
          >
            See Less
          </Button>
        ) : null}
      </Box> */}
    </Container>
    </>
  );
};

export default PathwayLights;